import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileArrowDown } from "@fortawesome/free-solid-svg-icons";
import PolicyEn from "../../assets/files/masarPolicyEn.pdf";
import PolicyAr from "../../assets/files/masarPolicyAr.pdf";

export function PrivecyPolicyAr() {

    return (
        <div className="container">
            <h4 className="text-center c-darkBeige">سياسة الخصوصية لمنصة مسار</h4>

            <h6 className="c-darkOrange"><strong>أ&ndash; مقدمة</strong></h6>
            <ol>
                <li>
                    إننا نهتم بشكل كبير بخصوصية زوار موقعنا، ونتعهد بحمايتها. تشرح هذه السياسة كيفية التصرف في معلوماتك الشخصية.
                </li>
                <li>
                    بموافقتك على استخدامنا لملفات تعريف الارتباط وفقًا لبنود هذه السياسة عند زيارتك لموقعنا الإلكتروني لأول مرة فإنك تسمح لنا باستخدام ملفات تعريف الارتباط في كل مرة تزور فيها موقعنا.
                </li>
            </ol>
            <h6 className="c-darkOrange"><strong>ب&ndash; جمع المعلومات الشخصية</strong></h6>

            <ol>
                <li>
                    قد يتم جمع وتخزين واستخدام المعلومات الشخصية التالية: معلومات حول جهاز الكمبيوتر الخاص بك بما في ذلك عنوان بروتوكول الإنترنت الخاص بك، والموقع الجغرافي، ونوع المتصفح والإصدار، ونظام التشغيل.
                </li>
                <li>
                    معلومات حول زياراتك لهذا الموقع واستخدامه بما في ذلك مصدر الإحالة، ومدة الزيارة، وما تشاهده على الصفحة، ومسارات التصفح في الموقع.
                </li>
                <li>
                    المعلومات التي تدخلها عند التسجيل في موقعنا الإلكتروني، مثل عنوان بريدك الإلكتروني، ورقم الجوال.
                </li>
                <li>
                    المعلومات التي تدخلها عند إنشاء ملف تعريف على موقعنا &ndash; على سبيل المثال، اسمك، صور ملفك الشخصي، الجنس، تاريخ الميلاد، الحالة الاجتماعية، الاهتمامات والهوايات، الحالة التعليمية، وتفاصيل الوظيفة.
                </li>
                <li>
                    المعلومات، مثل اسمك وعنوان بريدك الإلكتروني، التي تدخلها من أجل إعداد اشتراكات في رسائل البريد الإلكتروني و / أو الرسائل الإخبارية لدينا.
                </li>
                <li>
                    المعلومات التي تدخلها أثناء استخدام الخدمات على موقعنا.
                </li>
                <li>
                    المعلومات التي يتم إنشاؤها أثناء استخدام موقعنا الإلكتروني، بما في ذلك مواعيد وتكرار استخدامك للموقع والظروف التي تستخدم فيها الموقع.
                </li>
                <li>
                    المعلومات المتعلقة بأي شيء تشتريه، أو الخدمات التي تستخدمها، أو المعاملات التي تجريها من خلال موقعنا الإلكتروني، والتي تشمل اسمك وعنوانك ورقم هاتفك وعنوان بريدك الإلكتروني وتفاصيل بطاقة الائتمان.
                </li>
                <li>
                    المعلومات التي تنشرها على موقعنا الإلكتروني بغرض مشاركتها على الإنترنت، والتي تشمل اسم المستخدم الخاص بك وصور ملفك الشخصي ومحتوى مشاركاتك.
                </li>
                <li>
                    المعلومات الواردة في أي مراسلات ترسلها إلينا عبر البريد الإلكتروني أو عبر موقعنا الإلكتروني، بما في ذلك المحتوى المشترك والبيانات الوصفية.
                </li>
                <li>
                    أي معلومات شخصية أخرى ترسلها إلينا.
                </li>
            </ol>
            <p className="w-75 mx-auto bg-white p-1 rounded">
                قبل أن تفصح لنا عن المعلومات الشخصية الخاصة بشخص آخر، ينبغي عليك الحصول على موافقة هذا الشخص على كل من الكشف عن هذه المعلومات الشخصية ومعالجتها وفقًا لهذه السياسة.
            </p>
            <h6 className="c-darkOrange"><strong>ج&ndash; استخدام معلوماتك الشخصية</strong></h6>
            <p className="fw-bold">
                تستخدم المعلومات الشخصية المقدمة إلينا عبر موقعنا الإلكتروني في الأغراض الموضحة في هذه السياسة أو على الصفحات ذات الصلة من الموقع. قد نستخدم معلوماتك الشخصية في الأغراض التالية:
            </p>
            <ol>
                <li>
                    إدارة موقعنا وأعمالنا على شبكة الإنترنت.
                </li>
                <li>
                    تخصيص موقعنا على شبكة الإنترنت ليكون أكثر ملاءمة بالنسبة لك.
                </li>
                <li>
                    تمكينك من استخدام الخدمات المتاحة على موقعنا.
                </li>
                <li>
                    إرسال البضائع التي تشتريها من الإنترنت إليك.
                </li>
                <li>
                    توفير الخدمات المشتراة من خلال موقعنا على شبكة الإنترنت.
                </li>
                <li>
                    إرسال البيانات والفواتير وإشعارات الدفع لك، وتحصيل المدفوعات منك.
                </li>
                <li>
                    إرسال رسائل تجارية غير تسويقية إليك.
                </li>
                <li>
                    إرسال إشعارات عبر البريد الإلكتروني التي قمت بطلب إرسالها على وجه التحديد إليك.
                </li>
                <li>
                    إرسال نشرة البريد الإلكتروني إليك، إذا كنت قد طلبت ذلك (يمكنك إبلاغنا في أي وقت إذا لم تعد تحتاج إلى النشرة الإخبارية).
                </li>
                <li>
                    إرسال المراسلات التسويقية المتعلقة بأعمالنا أو أعمال الجهات الخارجية التي تم اختيارها بعناية والتي نعتقد أنها قد تهمك، عن طريق البريد أو، إذا كنت قد وافقت على ذلك بالتحديد، عن طريق البريد الإلكتروني أو أي تقنية مشابهة (يمكنك إبلاغنا في أي وقت إذا لم تعد تحتاج إلى هذه المراسلات التسويقية).
                </li>
                <li>
                    تزويد الأطراف الثالثة بمعلومات إحصائية عن مستخدمينا (غير أن هذه الأطراف الثالثة لن تتمكن من تحديد المستخدمين لتلك المعلومات بحد ذاتهم).
                </li>
                <li>
                    التعامل مع الاستفسارات والشكاوى التي تقدمها أنت أو تقدم لنا بشأنك على موقعنا.
                </li>
                <li>
                    حماية موقعنا من الاحتيال والحفاظ على أمنه.
                </li>
                <li>
                    التحقق من الامتثال للشروط والأحكام التي تحكم استخدام موقعنا الإلكتروني (بما في ذلك مراقبة الرسائل الخاصة المرسلة عبر خدمة الرسائل الخاصة بموقعنا).
                </li>
                <li>
                    استخدامات أخرى:
                    <ul>
                        <li>
                            إذا قمت بتقديم معلومات شخصية للنشر على موقعنا، فسنقوم بنشر هذه المعلومات واستخدامها بشكل آخر وفقًا للترخيص الذي تمنحه لنا.
                        </li>
                        <li>
                            يمكن استخدام إعدادات الخصوصية الخاصة بك للحد من نشر معلوماتك على موقعنا الإلكتروني ويمكن تعديلها باستخدام عناصر التحكم في الخصوصية على الموقع.
                        </li>
                        <li>
                            لن نزود أي طرف ثالث، دون موافقتك الصريحة، بمعلوماتك الشخصية لأغراض التسويق المباشر لأي طرف آخر.
                        </li>
                    </ul>
                </li>
            </ol>
            <h6 className="c-darkOrange"><strong>د&ndash; الكشف عن المعلومات الشخصية</strong></h6>
            <p className="fw-bold">
                يمكن أن نقوم بالكشف عن معلوماتك الشخصية لأي من موظفينا أو مسؤولينا أو شركات التأمين أو المستشارين المحترفين أو الوكلاء أو الموردين أو المقاولين من الباطن التابعين لنا القدر الضروري بشكل معقول للأغراض المنصوص عليها في هذه السياسة.
                <br />
                قد نقوم بالإفصاح عن معلوماتك الشخصية لأي عضو في مجموعة شركاتنا (وهذا يعني الشركات التابعة لنا، والشركة القابضة الأصلية وجميع فروعها) بالقدر الضروري بشكل معقول للأغراض المنصوص عليها في هذه السياسة.
                قد نكشف عن معلوماتك الشخصية:
            </p>
            <ol>
                <li>
                    القدر الذي يطلب منا القيام به بموجب القانون.
                </li>
                <li>
                    فيما يتعلق بأي إجراءات قانونية جارية أو محتملة.
                </li>
                <li>
                    من أجل إنشاء أو ممارسة أو الدفاع عن حقوقنا القانونية (بما في ذلك توفير معلومات للآخرين لأغراض منع الاحتيال والحد من مخاطر الائتمان).
                </li>
                <li>
                    إلى المشتري (أو المشتري المحتمل) لأي عمل أو أصل نبيعه (أو ننوي ذلك).
                </li>
                <li>
                    أي شخص نعتقد على نحو معقول أنه قد يتقدم بطلب إلى محكمة أو سلطة مختصة أخرى بطلب الإفصاح عن تلك المعلومات الشخصية، وفقًا لتقديرنا المعقول، ويكون من المحتمل بشكل معقول أن تأمر هذه المحكمة أو السلطة بالكشف عن تلك المعلومات الشخصية. باستثناء ما هو منصوص عليه في هذه السياسة، فإننا لن نقدم معلوماتك الشخصية إلى أطراف ثالثة.
                </li>
            </ol>
            <h6 className="c-darkOrange"><strong>هـ&ndash; النقل الدولي للبيانات</strong></h6>
            <ol>
                <li>
                    قد يتم تخزين المعلومات التي نجمعها أو معالجتها أو نقلها بين أي من البلدان التي نعمل فيها لتمكيننا من استخدام المعلومات وفقًا لهذه السياسة.
                </li>
                <li>
                    قد يتم نقل المعلومات التي نجمعها إلى البلدان التالية والتي لا تخضع لقوانين حماية البيانات المكافئة لتلك المعمول بها في المنطقة الاقتصادية الأوروبية: وهذه الدول هي الولايات المتحدة الأمريكية، روسيا، اليابان، الصين، والهند.
                </li>
                <li>
                    لا نستطيع منع استخدام الآخرين أو إساءة استخدامهم للمعلومات الشخصية التي تنشرها على موقعنا الإلكتروني أو ترسلها للنشر على موقعنا الإلكتروني والمتاحة عبر الإنترنت في جميع أنحاء العالم.
                </li>
                <li>
                    أنت توافق صراحة على عمليات نقل المعلومات الشخصية الموضحة في هذا القسم &ldquo;هـ&rdquo;.
                </li>
            </ol>

            <h6 className="c-darkOrange"><strong>و&ndash; الاحتفاظ بالمعلومات الشخصية</strong></h6>
            <ol>
                <li>
                    &nbsp;يحدد هذا القسم &ldquo;و&rdquo; السياسات والإجراءات التي نتبعها للاحتفاظ بالبيانات، والتي صممت للمساعدة في ضمان امتثالنا لالتزاماتنا القانونية المتعلقة بالاحتفاظ بالمعلومات الشخصية وحذفها.
                </li>
                <li>
                    لا يجوز الاحتفاظ بالمعلومات الشخصية التي نقوم بمعالجتها لأي غرض أو أغراض لفترة أطول مما هو ضروري لهذا الغرض أو لتلك الأغراض.
                </li>
                <li>
                    بصرف النظر عن الأحكام الأخرى الواردة في هذا القسم و، فإننا نحتفظ بالوثائق (بما في ذلك المستندات الإلكترونية) التي تحتوي على بيانات شخصية:
                    <ul>
                        <li>
                            بالقدر المطلوب بموجب القانون.
                        </li>
                        <li>
                            إذا كنا نعتقد أن هذه المستندات قد تكون ذات صلة بأي إجراءات قانونية جارية أو محتملة.
                        </li>
                        <li>
                            من أجل بدء أو ممارسة أو الدفاع عن حقوقنا القانونية (بما في ذلك توفير المعلومات للآخرين لأغراض منع الاحتيال والحد من مخاطر الائتمان).
                        </li>
                    </ul>
                </li>
            </ol>

            <h6 className="c-darkOrange"><strong>ز&ndash; أمن معلوماتك الشخصية</strong></h6>

            <ol>
                <li>
                    أمن معلوماتك الشخصية: نتعهد باتخاذ الاحتياطات التقنية والتنظيمية المعقولة لمنع فقدان معلوماتك الشخصية أو إساءة استخدامها أو تغييرها.
                </li>
                <li>
                    نتعهد بتخزين جميع المعلومات الشخصية التي تقدمها على خوادمنا الآمنة (المحمية بكلمة مرور وجدار الحماية).
                </li>
                <li>
                    جميع المعاملات المالية الإلكترونية التي يتم القيام بها من خلال موقعنا الإلكتروني محمية بتقنية التشفير.
                </li>
                <li>
                    تقرّ بموافقتك على هذه السياسة بمعرفتك بأن نقل المعلومات عبر الإنترنت غير آمن بطبيعته، ولا يمكننا ضمان أمن البيانات المرسلة عبر الإنترنت.
                </li>
                <li>
                    أنت مسؤول عن الحفاظ على سرية كلمة المرور التي تستخدمها للوصول إلى موقعنا. لن نطلب منك كلمة المرور الخاصة بك (إلا عند تسجيل الدخول إلى موقعنا).
                </li>
            </ol>

            <h6 className="c-darkOrange"><strong>ح&ndash; التعديلات</strong></h6>
            <p>قد نقوم بتحديث هذه السياسة من وقت لآخر عن طريق نشر نسخة جديدة على موقعنا. يجب عليك مراجعة هذه الصفحة من حين لآخر للتأكد من فهمك لأي تغييرات تطرأ على هذه السياسة، وقد نخطرك بالتغييرات التي تطرأ على هذه السياسة عن طريق البريد الإلكتروني أو من خلال نظام المراسلة الخاص على موقعنا.</p>

            <h6 className="c-darkOrange"><strong>ط&ndash; حقوقك</strong></h6>
            <ol>
                <li>
                    قد تطلب منا تزويدك بأي معلومات شخصية نحتفظ بها عنك، يخضع توفير هذه المعلومات لما يلي:
                    <ul>
                        <li>
                            دفع الرسوم (تحدد الرسوم من قبل الإدارة وترسل لكم في فاتورة رسمية).
                        </li>
                        <li>
                            وتقديم إثبات الهوية المناسب (طبقا لمحل الإقامة والدولة والسياسات المتبعة وقتها) .
                        </li>
                    </ul>
                </li>
                <li>
                    قد نمتنع عن تزويدك بالمعلومات الشخصية التي تطلبها بالقدر الذي يسمح به القانون.
                </li>
                <li>
                    قد تطلب منا في أي وقت عدم معالجة معلوماتك الشخصية لأغراض التسويق.
                </li>
                <li>
                    من الناحية العملية، إما أنك ستوافق بشكل صريح مسبقًا على استخدامنا لمعلوماتك الشخصية لأغراض التسويق، أو سنمنحك فرصة لإلغاء الاشتراك في استخدام معلوماتك الشخصية لأغراض التسويق.
                </li>
            </ol>
            <h6 className="c-darkOrange"><strong>ي&ndash; مواقع الطرف الثالث</strong></h6>
            <p>
                قد يشتمل موقعنا على روابط تشعبية وتفاصيل عن مواقع خاصة بأطراف ثالثة، علمًا بأنه ليس لدينا أي سيطرة على سياسات الخصوصية وممارسات الأطراف الثالثة كما أننا لسنا مسؤولين عنها.
            </p>

            <h6 className="c-darkOrange"><strong>ك&ndash; تحديث المعلومات</strong></h6>
            <p>
                يرجى إعلامنا إذا كانت المعلومات الشخصية التي نحتفظ بها عنك تحتاج إلى تصحيح أو تحديث.
            </p>

            <h6 className="c-darkOrange"><strong>ل&ndash; ملفات تعريف الارتباط</strong></h6>

            يستخدم موقعنا ملفات تعريف الارتباط. ملف تعريف الارتباط هو ملف يحتوي على معرف (سلسلة من الحروف والأرقام) يتم إرساله بواسطة خادم الإنترنت إلى متصفح الإنترنت ويتم تخزينه بواسطة المتصفح، ثم يتم إرسال المعرف مرة أخرى إلى الخادم في كل مرة يطلب فيها المتصفح صفحة من الخادم. قد تكون ملفات تعريف الارتباط إما ملفات تعريف ارتباط &ldquo;دائمة&rdquo; أو ملفات تعريف ارتباط خاصة بـ &ldquo;جلسة&rdquo;: يخزن ملف تعريف الارتباط الدائم بواسطة متصفح الإنترنت ويظل صالحًا حتى تاريخ انتهاء الصلاحية المحدد له، ما لم يتم حذفه من قبل المستخدم قبل تاريخ انتهاء الصلاحية؛ من ناحية أخرى، تنتهي صلاحية ملف تعريف ارتباط الجلسة بنهاية جلسة المستخدم، أي بإغلاق متصفح الإنترنت. لا تحتوي ملفات تعريف الارتباط عادةً على أي معلومات تعرّف عن المستخدم شخصيًا، ولكن قد يتم ربط المعلومات الشخصية التي نخزنها عنك بالمعلومات المخزنة في ملفات تعريف الارتباط التي يتم الحصول عليها.

            <ol>
                <li>
                    فيما يلي أسماء ملفات تعريف الارتباط التي نستخدمها على موقعنا الإلكتروني والأغراض التي تستخدم من أجلها :
                    <ul>
                        <li>
                            نستخدم تحليلات جوجل و Adwords على موقعنا للتعرف على جهاز الكمبيوتر عندما يقوم المستخدم بـ ( زيارة الموقع الإلكتروني / تتبع المستخدمين أثناء تصفحهم للموقع / تمكين استخدام عربة التسوق على الموقع / تحسين قابلية استخدام الموقع / تحليل استخدام الموقع / إدارة الموقع / منع الاحتيال وتحسين أمن الموقع / تخصيص الموقع لكل مستخدم / الإعلانات المستهدفة التي قد تكون ذات أهمية خاصة لمستخدمين محددين).
                        </li>
                    </ul>
                </li>
                <li>
                    تسمح لك معظم المتصفحات برفض قبول ملفات تعريف الارتباط &mdash; على سبيل المثال:
                    <ul>
                        <li>
                            في متصفح إنترنت إكسبلورر Internet Explorer (الإصدار 10)، يمكنك حظر ملفات تعريف الارتباط باستخدام إعدادات تجاوز التعامل مع ملفات تعريف الارتباط المتاحة بالنقر فوق &rdquo; أدوات&rdquo;، و &ldquo;خيارات إنترنت&rdquo;، و &ldquo;الخصوصية&rdquo;، ثم &ldquo;خيارات متقدمة&rdquo;.
                        </li>
                        <li>
                            في متصفح فايرفوكس Firefox (الإصدار 24)، يمكنك حظر جميع ملفات تعريف الارتباط عن طريق النقر على &ldquo;أدوات&rdquo;، و &ldquo;خيارات&rdquo;، و &ldquo;خصوصية&rdquo;، وتحديد &ldquo;استخدام الإعدادات المخصصة للتاريخ&rdquo; من القائمة المنسدلة، وإلغاء تحديد &ldquo;قبول ملفات تعريف الارتباط من المواقع&rdquo; .
                        </li>
                        <li>
                            في كروم Chrome (الإصدار 29)، يمكنك حظر جميع ملفات تعريف الارتباط عن طريق الوصول إلى قائمة &ldquo;تخصيص والتحكم&rdquo;، والنقر على &ldquo;الإعدادات&rdquo;، و &ldquo;إظهار الإعدادات المتقدمة&rdquo;، و &ldquo;إعدادات المحتوى&rdquo;، ثم تحديد &ldquo;حظر المواقع من إعداد أي بيانات&rdquo; تحت عنوان&rdquo; ملفات تعريف الارتباط &ldquo;.
                        </li>
                    </ul>
                </li>
                <li>
                    سيكون لحظر جميع ملفات تعريف الارتباط تأثير سلبي على سهولة استخدام العديد من المواقع. إذا قمت بحظر ملفات تعريف الارتباط، فلن تتمكن من استخدام جميع الميزات الموجودة على موقعنا.يمكنك حذف ملفات تعريف الارتباط المخزنة بالفعل على جهاز الكمبيوتر الخاص بك &ndash; على سبيل المثال:
                    <ul>
                        <li>
                            في إنترنت إكسبلورر Internet Explorer (الإصدار 10)، يجب عليك حذف ملفات تعريف الارتباط يدويًا (يمكنك العثور على تعليمات للقيام بذلك عبر  <a href="http://support.microsoft.com/kb/278835">الرابط التالي</a> ).
                        </li>
                        <li>
                            في فايرفوكس Firefox (الإصدار 24)، يمكنك حذف ملفات تعريف الارتباط بالنقر فوق &ldquo;أدوات&rdquo; و &ldquo;خيارات&rdquo; و &ldquo;خصوصية&rdquo;، ثم تحديد &ldquo;استخدام إعدادات مخصصة للتاريخ&rdquo;، والنقر فوق &ldquo;إظهار ملفات تعريف الارتباط&rdquo;، ثم النقر فوق &ldquo;إزالة&rdquo; جميع ملفات تعريف الارتباط &ldquo;؛
                        </li>
                        <li>
                            في كروم Chrome (الإصدار 29)، يمكنك حذف جميع ملفات تعريف الارتباط عن طريق الوصول إلى قائمة &ldquo;تخصيص والتحكم&rdquo;، والنقر على &ldquo;الإعدادات&rdquo;، و &ldquo;إظهار الإعدادات المتقدمة&rdquo;، و &ldquo;مسح بيانات التصفح&rdquo;، ثم تحديد &ldquo;حذف ملفات تعريف الارتباط و بيانات الموقع والمكونات الإضافية الأخرى &ldquo;قبل النقر فوق&rdquo; مسح بيانات التصفح &ldquo;.
                        </li>
                    </ul>
                </li>
            </ol>
            <p className="text-end">إدارة منصة مسار لتقنية المعلومات
                <br />
                <a href="/ar/contact-us" className="btn-masar text-black btn-med-gray text-decoration-none p-2">تواصل معنا</a>

                <a href={PolicyAr} target="_blank" rel="noreferrer" className="btn-masar btn-dark-orange text-decoration-none px-2 p-0 float-end mx-2">
                    تحميل <FontAwesomeIcon icon={faFileArrowDown} />
                </a>
            </p>
        </div>
    )

}


export function PrivecyPolicyEn() {
    return (
        <div className="container">
            <h4 className="text-center c-darkBeige">Privacy Policy for Masar Platform</h4>

            <h6 className="c-darkOrange"><strong>A&ndash; Introduction</strong></h6>
            <ol>
                <li>
                    We greatly value the privacy of our website visitors and are committed to protecting it. This policy explains how we handle your personal information.
                </li>
                <li>
                    By agreeing to our use of cookies in accordance with the terms of this policy when you first visit our website, you allow us to use cookies every time you visit our website.
                </li>
            </ol>
            <h6 className="c-darkOrange"><strong>B&ndash; Collecting Personal Information</strong></h6>

            <ol>
                <li>
                    The following personal information may be collected, stored, and used: information about your computer including your IP address, geographical location, browser type and version, and operating system.
                </li>
                <li>
                    Information about your visits to and use of this website including the referral source, duration of visit, page views, and website navigation paths.
                </li>
                <li>
                    Information you enter when you register on our website, such as your email address and mobile number.
                </li>
                <li>
                    Information you enter when creating a profile on our website &ndash; for example, your name, profile pictures, gender, date of birth, marital status, interests and hobbies, educational status, and employment details.
                </li>
                <li>
                    Information, such as your name and email address, that you enter to set up subscriptions to our emails and/or newsletters.
                </li>
                <li>
                    Information you enter while using the services on our website.
                </li>
                <li>
                    Information that is generated while using our website, including the timing, frequency, and circumstances of your use.
                </li>
                <li>
                    Information relating to anything you purchase, services you use, or transactions you make through our website, which includes your name, address, phone number, email address, and credit card details.
                </li>
                <li>
                    Information that you post to our website with the intention of publishing it on the internet, which includes your username, profile pictures, and the content of your posts.
                </li>
                <li>
                    Information contained in any correspondence you send to us via email or through our website, including shared content and metadata.
                </li>
                <li>
                    Any other personal information you send to us.
                </li>
            </ol>
            <p className="w-75 mx-auto bg-white p-1 rounded">
                Before you disclose to us the personal information of another person, you must obtain that person's consent to both the disclosure and the processing of that personal information in accordance with this policy.
            </p>
            <h6 className="c-darkOrange"><strong>C&ndash; Using Your Personal Information</strong></h6>
            <p className="fw-bold">
                Personal information submitted to us through our website will be used for the purposes specified in this policy or on the relevant pages of the website. We may use your personal information for the following purposes:
            </p>
            <ol>
                <li>
                    Administering our website and business.
                </li>
                <li>
                    Personalizing our website for you.
                </li>
                <li>
                    Enabling your use of the services available on our website.
                </li>
                <li>
                    Sending you goods purchased through our website.
                </li>
                <li>
                    Supplying services purchased through our website.
                </li>
                <li>
                    Sending statements, invoices, and payment reminders to you, and collecting payments from you.
                </li>
                <li>
                    Sending you non-marketing commercial communications.
                </li>
                <li>
                    Sending you email notifications that you have specifically requested.
                </li>
                <li>
                    Sending you our email newsletter, if you have requested it (you can inform us at any time if you no longer require the newsletter).
                </li>
                <li>
                    Sending you marketing communications relating to our business or the businesses of carefully selected third parties which we think may be of interest to you, by post or, where you have specifically agreed to this, by email or similar technology (you can inform us at any time if you no longer require marketing communications).
                </li>
                <li>
                    Providing third parties with statistical information about our users (but those third parties will not be able to identify any individual user from that information).
                </li>
                <li>
                    Dealing with inquiries and complaints made by or about you relating to our website.
                </li>
                <li>
                    Keeping our website secure and preventing fraud.
                </li>
                <li>
                    Verifying compliance with the terms and conditions governing the use of our website (including monitoring private messages sent through our website's private messaging service).
                </li>
                <li>
                    Other uses:
                    <ul>
                        <li>
                            If you submit personal information for publication on our website, we will publish and otherwise use that information in accordance with the license you grant to us.
                        </li>
                        <li>
                            Your privacy settings can be used to limit the publication of your information on our website and can be adjusted using privacy controls on the website.
                        </li>
                        <li>
                            We will not, without your express consent, supply your personal information to any third party for their or any other third party's direct marketing.
                        </li>
                    </ul>
                </li>
            </ol>
            <h6 className="c-darkOrange"><strong>D&ndash; Disclosing Personal Information</strong></h6>
            <p className="fw-bold">
                We may disclose your personal information to any of our employees, officers, insurers, professional advisers, agents, suppliers, or subcontractors as reasonably necessary for the purposes set out in this policy.
                <br />
                We may disclose your personal information to any member of our group of companies (this means our subsidiaries, our ultimate holding company, and all its subsidiaries) as reasonably necessary for the purposes set out in this policy.
                We may disclose your personal information:
            </p>
            <ol>
                <li>
                    To the extent that we are required to do so by law.
                </li>
                <li>
                    In connection with any ongoing or prospective legal proceedings.
                </li>
                <li>
                    In order to establish, exercise, or defend our legal rights (including providing information to others for the purposes of fraud prevention and reducing credit risk).
                </li>
                <li>
                    To the purchaser (or prospective purchaser) of any business or asset that we are (or are contemplating) selling.
                </li>
                <li>
                    To any person who we reasonably believe may apply to a court or other competent authority for disclosure of that personal information where, in our reasonable opinion, such court or authority would be reasonably likely to order disclosure of that personal information. Except as provided in this policy, we will not provide your personal information to third parties.
                </li>
            </ol>
            <h6 className="c-darkOrange"><strong>E&ndash; International Data Transfers</strong></h6>
            <ol>
                <li>
                    Information that we collect may be stored and processed in and transferred between any of the countries in which we operate to enable us to use the information in accordance with this policy.
                </li>
                <li>
                    Information that we collect may be transferred to the following countries which do not have data protection laws equivalent to those in force in the European Economic Area: the United States of America, Russia, Japan, China, and India.
                </li>
                <li>
                    You expressly agree to the transfers of personal information described in this section "E".
                </li>
            </ol>
            <p className="text-end">Masar Information Technology Platform Management
                <br />
                <a href="/en/contact-us" className="btn-masar text-black btn-med-gray text-decoration-none p-2">Contact Us</a>

                <a href={PolicyEn} target="_blank" rel="noreferrer" className="btn-masar btn-dark-orange text-decoration-none px-2 p-0 float-end mx-2">
                    Download <FontAwesomeIcon icon={faFileArrowDown} />
                </a>
            </p>
        </div>
    )

}